export const CAMPAIGNS_LIST = {
  UPDATE_AUDIENCE_COUNT: 'CAMPAIGNS_LIST_UPDATE_AUDIENCE_COUNT',
  LOAD: 'CAMPAIGNS_LIST_LOAD',
  SUCCESS: 'CAMPAIGNS_LIST_LOAD_SUCCESS',
  ERROR_SEARCH_TERM: 'CAMPAIGNS_LIST_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'CAMPAIGNS_LIST_ERROR_SEARCH_TERM_LOADING',
  FAIL: 'CAMPAIGNS_LIST_LOAD_FAIL',
  RESET: 'CAMPAIGNS_LIST_LOAD_RESET',
  ADD_NEW: 'CAMPAIGNS_LIST_ADD_NEW',
  UPDATE_ASSET_COUNT: 'CAMPAIGNS_LIST_UPDATE_ASSET_COUNT',
  UPDATE_THUMBNAIL: 'CAMPAIGNS_LIST_UPDATE_THUMBNAIL',
  RESET_CAMPAIGN_PAGE: 'CAMPAIGNS_LIST_RESET_CAMPAIGN_PAGE',
  CLONE: 'CAMPAIGNS_LIST_CLONE',
  CLONE_IN_PROGRESS: 'CAMPAIGNS_LIST_CLONE_IN_PROGRESS',
  SET_USERS: 'CAMPAIGNS_LIST_SET_USERS',
  SET_EMAIL_USERS: 'CAMPAIGNS_LIST_SET_EMAIL_USERS',
  PREV_ID: 'CAMPAIGNS_LIST_PREV_ID',
  RESET_FLAG: 'CAMPAIGNS_LIST_RESET_FLAG',
  APPEND_CAMPAIGN_AT_START: 'APPEND_CAMPAIGN_AT_START',
};

export const CAMPAIGN_NAME_UPDATE = {
  LOAD: 'CAMPAIGNS_NAME_LOAD',
  SUCCESS: 'CAMPAIGNS_NAME_LOAD_SUCCESS',
  FAIL: 'CAMPAIGNS_NAME_LOAD_FAIL',
};

export const ASSET_LIST = {
  LOAD: 'ASSET_LIST_LOAD',
  SUCCESS: 'ASSET_LIST_LOAD_SUCCESS',
  SET_CAMPAIGN_DETAILS: 'ASSET_LIST_SET_CAMPAIGN_DETAILS',
  FAIL: 'ASSET_LIST_LOAD_FAIL',
  RESET: 'ASSET_LIST_LOAD_RESET',
  UPDATE_KEYWORDS: 'ASSET_LIST_UPDATE_KEYWORDS',
  ADVANCED_SEARCH: 'ASSET_LIST_ADVANCED_SEARCH',
  RESET_ADVANCED_SEARCH: 'ASSET_LIST_RESET_ADVANCED_SEARCH',
};

export const EMAIL_LIST = {
  // campaign actions
  DRAFT_EMAILS_RESET_LOAD: 'EMAIL_LIST_DRAFT_EMAILS_RESET_LOAD',
  SENT_LOAD_OFF: 'EMAIL_LIST_SENT_LOAD_OFF',
  RESET: 'EMAIL_LIST_RESET',
  SET_CAMPAIGN_DETAILS: 'EMAIL_LIST_SET_CAMPAIGN_DETAILS',
  UPDATE_CAMPAIGN_NAME: 'EMAIL_LIST_UPDATE_CAMPAIGN_NAME',
  UPDATE_CAMPAIGN_KEYWORDS: 'EMAIL_LIST_UPDATE_CAMPAIGN_KEYWORDS',
  RESET_CAMPAIGN_DETAILS: 'EMAIL_LIST_RESET_CAMPAIGN_DETAILS',
  CAMPAIGN_KEYWORDS_WHEN_CREATING_NEW_EMAIL: 'EMAIL_LIST_CAMPAIGN_KEYWORDS_WHEN_CREATING_NEW_EMAIL',
  RESET_CAMPAIGN_KEYWORDS_WHEN_CREATING_NEW_EMAIL: 'EMAIL_LIST_RESET_CAMPAIGN_KEYWORDS_WHEN_CREATING_NEW_EMAIL',
  EMAIL_IN_EXISTING_CAMPAIGN: 'EMAIL_LIST_EMAIL_IN_EXISTING_CAMPAIGN',
  DRAFT_EMAILS_RESET: 'EMAIL_LIST_DRAFT_EMAILS_RESET',
  // draft actions
  DRAFT_LOAD: 'EMAIL_LIST_LOAD',
  DRAFT_SUCCESS: 'EMAIL_LIST_SUCCESS',
  DRAFT_UPDATE: 'EMAIL_LIST_DRAFT_UPDATE',
  DRAFT_RESET: 'EMAIL_LIST_RESET',
  DRAFT_FAIL: 'EMAIL_LIST_FAIL',
  DRAFT_UPDATE_IMAGES: 'EMAIL_LIST_DRAFT_UPDATE_IMAGES',
  CLONE_DRAFT_SUCCESS: 'EMAIL_LIST_CLONE_DRAFT_SUCCESS',
  CLONE_DRAFT_IN_PROGRESS: 'EMAIL_LIST_CLONE_DRAFT_IN_PROGRESS',
  // email builder actions
  ADD_EMAIL_SUCCESS: 'EMAIL_LIST_ADD_EMAIL_SUCCESS',
  ADD_EMAIL_FAIL: 'EMAIL_LIST_ADD_EMAIL_FAIL',
  ADD_EMAIL_RESET: 'EMAIL_LIST_ADD_EMAIL_RESET',
  // email graph actions
  GRAPH_LOAD: 'EMAIL_LIST_GRAPH_LOAD',
  GRAPH_SUCCESS: 'EMAIL_LIST_GRAPH_SUCCESS',
  GRAPH_FAIL: 'EMAIL_LIST_GRAPH_FAIL',
  GRAPH_CLEAR: 'EMAIL_LIST_GRAPH_CLEAR',
  GRAPH_SET_DATES: 'EMAIL_LIST_GRAPH_SET_DATES',
  GRAPH_SET_USER: 'EMAIL_LIST_GRAPH_SET_USER',
  // sent actions
  SENT_LOAD: 'EMAIL_LIST_SENT_LOAD',
  SENT_SUCCESS: 'EMAIL_LIST_SENT_SUCCESS',
  SENT_FAIL: 'EMAIL_LIST_SENT_FAIL',
  SENT_RESET: 'EMAIL_LIST_SENT_RESET',

  // test actions
  TEST_LOAD: 'EMAIL_LIST_TEST_LOAD',
  TEST_SUCCESS: 'EMAIL_LIST_TEST_SUCCESS',
  TEST_FAIL: 'EMAIL_LIST_TEST_FAIL',
  TEST_RESET: 'EMAIL_LIST_TEST_RESET',
  TEST_LOAD_OFF: 'EMAIL_LIST_TEST_LOAD_OFF',

  // all actions
  ALL_LOAD: 'EMAIL_LIST_ALL_LOAD',
  ALL_SUCCESS: 'EMAIL_LIST_ALL_SUCCESS',
  ALL_FAIL: 'EMAIL_LIST_ALL_FAIL',
  ALL_RESET: 'EMAIL_LIST_ALL_RESET',
  ALL_LOAD_OFF: 'EMAIL_LIST_ALL_LOAD_OFF',

  // all sent actions
  ALL_SENT_LOAD: 'EMAIL_LIST_ALL_SENT_LOAD',
  ALL_SENT_SUCCESS: 'EMAIL_LIST_ALL_SENT_SUCCESS',
  ALL_SENT_FAIL: 'EMAIL_LIST_ALL_SENT_FAIL',
  ALL_SENT_RESET: 'EMAIL_LIST_ALL_SENT_RESET',
  ALL_SENT_LOAD_OFF: 'EMAIL_LIST_ALL_SENT_LOAD_OFF',

  //Scheduled Actions
  SCHEDULED_LOAD: 'EMAIL_LIST_SCHEDULED_LOAD',
  SCHEDULED_SUCCESS: 'EMAIL_LIST_SCHEDULED_SUCCESS',
  SCHEDULED_FAIL: 'EMAIL_LIST_SCHEDULED_FAIL',
  SCHEDULED_RESET: 'EMAIL_LIST_SCHEDULED_RESET',
  SCHEDULED_LOAD_OFF: 'EMAIL_LIST_SCHEDULED_LOAD_OFF',

  SET_USER: 'SET_USER',
  SET_DATE: 'SET_DATE',
  SET_EMAIL_TYPE: 'SET_EMAIL_TYPE',
  SET_USER_FILTER: 'SET_USER_FILTER',
  RESET_CAMPAIGN_FILTERS: 'RESET_CAMPAIGN_FILTERS',

  // REST ALL CAMPAIGNS SENT, ALL, SCHEDULED, TEST
  RESET_ALL: 'RESET_ALL',

  STORE_DATES: 'STORE_DATES',
  STORE_USER: 'STORE_USER',

  // Store tab state
  SET_TAB_STATE: 'SET_TAB_STATE',
  RESET_TAB_STATE: 'RESET_TAB_STATE',

  // FOR ALPHA(α) CASE IN SEARCH
  ERROR_SEARCH_TERM: 'AUTOMATION_USER_WORKFLOWS_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'AUTOMATION_USER_WORKFLOWS_ERROR_SEARCH_TERM_LOADING',
  SET_RESEND_LOADING: 'EMAIL_LIST_SET_RESEND_LOADING',
  SET_RESEND_SUCCESS: 'EMAIL_LIST_SET_RESEND_SUCCESS',
};

export const ASSETS_WITHOUT_CAMPAIGNS_LIST = {
  LOAD: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_LOAD',
  SUCCESS: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_LOAD_SUCCESS',
  FAIL: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_LOAD_FAIL',
  RESET: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_LOAD_RESET',
  REMOVE: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_LOAD_REMOVE',
  RESET_NEWLY_ADDED: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_RESET_NEWLY_ADDED',
};

export const ASSETS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST = {
  LOAD: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD',
  SUCCESS: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_SUCCESS',
  FAIL: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_FAIL',
  RESET: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_RESET',
  REMOVE: 'ASSETS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_REMOVE',
};
export const EMAILS_WITHOUT_CAMPAIGNS_LIST = {
  LOAD: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_LOAD',
  SUCCESS: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_LOAD_SUCCESS',
  FAIL: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_LOAD_FAIL',
  RESET: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_LOAD_RESET',
  REMOVE: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_LOAD_REMOVE',
  RESET_NEWLY_ADDED: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_RESET_NEWLY_ADDED',
};

export const EMAILS_WITHOUT_CAMPAIGNS_DASHBOARD_LIST = {
  LOAD: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD',
  SUCCESS: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_SUCCESS',
  FAIL: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_FAIL',
  RESET: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_RESET',
  REMOVE: 'EMAILS_WITHOUT_CAMPAIGNS_LIST_DASHBOARD_LOAD_REMOVE',
};

export const ASSET = {
  LOAD: 'ASSET_LOAD',
  SUCCESS: 'ASSET_LOAD_SUCCESS',
  FAIL: 'ASSET_LOAD_FAIL',
};

export const CAMPAIGN_SENT_EDITIONS = {
  LOAD: 'CAMPAIGN_SENT_EDITIONS_LOAD',
  LOAD_SUCCESS: 'CAMPAIGN_SENT_EDITIONS_SUCCESS',
  LOAD_FAIL: 'CAMPAIGN_SENT_EDITIONS_FAIL',
  SET_NAME: 'SET_NAME',
  SET_VERSION_SUBJECT_SUCCESS: 'CAMPAIGN_SENT_EDITIONS_SET_VERSION_SUBJECT_SUCCESS',
  SET_VERSION_SUBJECT_LOADING: 'CAMPAIGN_SENT_EDITIONS_SET_VERSION_SUBJECT_LOADING',
  LOADER_HIDE: 'CAMPAIGN_SENT_EDITIONS_LOADER_HIDE',
  KEYWORDS_UPDATE: 'CAMPAIGN_SENT_EDITIONS_KEYWORDS_UPDATE',
};

export const ASSET_DELETE = {
  LOAD: 'ASSET_DELETE_STATUS_LOAD',
  SUCCESS: 'ASSET_DELETE_STATUS_SUCCESS',
  FAIL: 'ASSET_DELETE_STATUS_FAIL',
};

export const CAMPAIGN_DELETE = {
  LOAD: 'CAMPAIGN_DELETE_STATUS_LOAD',
  SUCCESS: 'CAMPAIGN_DELETE_STATUS_SUCCESS',
  FAIL: 'CAMPAIGN_DELETE_STATUS_FAIL',
  DECREMENT_ASSET_COUNT: 'CAMPAIGN_DELETE_DECREMENT_ASSET_COUNT',
};

export const ASSET_DELETED = 'ASSET_DELETED';
export const CAMPAIGN_NAME_DELETE = {
  SUCCESS: 'CAMPAIGN_NAME_DELETE_SUCCESS',
};

export const CREATE_CAMPAIGN_RECOMMENDED_LISTS = {
  LOAD: 'CREATE_CAMPAIGN_RECOMMENDED_LISTS_LOAD',
  SUCCESS: 'CREATE_CAMPAIGN_RECOMMENDED_LISTS_SUCCESS',
  FAIL: 'CREATE_CAMPAIGN_RECOMMENDED_LISTS_FAIL',
  RESET: 'CREATE_CAMPAIGN_RECOMMENDED_LISTS_RESET',
  CLEAR_DATA: 'CREATE_CAMPAIGN_RECOMMENDED_LISTS_CLEAR_DATA',
};

export const SELECTED_RECOMMENDED_LISTS = {
  SET: 'SELECTED_RECOMMENDED_LISTS_SET',
  RESET: 'SELECTED_RECOMMENDED_LISTS_RESET',
  SET_SELECT_ALL: 'SELECTED_RECOMMENDED_LISTS_SET_SELECT_ALL',
  RESET_SELECT_ALL: 'SELECTED_RECOMMENDED_LISTS_RESET_SELECT_ALL',
  SET_SELECT_ALL_FLAG: 'SELECTED_RECOMMENDED_LISTS_SET_SELECT_ALL_FLAG',
};

export const SELECTED_RECOMMENDED_CONTACTS = {
  SET: 'SELECTED_RECOMMENDED_CONTACTS_SET',
  RESET: 'SELECTED_RECOMMENDED_CONTACTS_RESET',
  SELECT_ALL_RECOMMENDED: 'SELECTED_RECOMMENDED_CONTACTS_SELECT_ALL_RECOMMENDED',
  UNSELECT_ALL_RECOMMENDED: 'SELECTED_RECOMMENDED_CONTACTS_UNSELECT_ALL_RECOMMENDED',
  SELECT_ALL_SEARCHED: 'SELECTED_RECOMMENDED_CONTACTS_SELECT_ALL_SEARCHED',
  UNSELECT_ALL_SEARCHED: 'SELECTED_RECOMMENDED_CONTACTS_UNSELECT_ALL_SEARCHED',
  SELECT_ALL_DYNAMIC: 'SELECTED_RECOMMENDED_CONTACTS_SELECT_ALL_DYNAMIC',
  UNSELECT_ALL_DYNAMIC: 'SELECTED_RECOMMENDED_CONTACTS_UNSELECT_ALL_DYNAMIC',
  RESET_SELECT_ALL_RECOMMENDED: 'SELECTED_RECOMMENDED_CONTACTS_RESET_SELECT_ALL_RECOMMENDED',
  RESET_SELECT_ALL_SEARCHED: 'SELECTED_RECOMMENDED_CONTACTS_RESET_SELECT_ALL_SEARCHED',
  RESET_SELECT_ALL_DYNAMIC: 'SELECTED_RECOMMENDED_CONTACTS_RESET_SELECT_ALL_DYNAMIC',
  RESET_ALL: 'SELECTED_RECOMMENDED_CONTACTS_RESET_ALL',
};

export const CREATE_CAMPAIGN_RECOMMENDED_CONTACTS = {
  LOAD: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_LOAD',
  SUCCESS: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_SUCCESS',
  FAIL: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_FAIL',
  RESET: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_RESET',
  CLEAR_DATA: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_CLEAR_DATA',
  SET_SELECTED_CONTACTS: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_SET_SELECTED_CONTACTS',
  RESET_SELECTED_CONTACTS: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_RESET_SELECTED_CONTACTS',
  SET_SELECT_ALL: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_SET_SELECT_ALL',
  RESET_SELECT_ALL: 'CREATE_CAMPAIGN_RECOMMENDED_CONTACTS_RESET_SELECT_ALL',
};

export const SET_REMINDER_TO_PUBLISH_DIGEST = {
  SET: 'SET_REMINDER_TO_PUBLISH_DIGEST_LOAD',
  SUCCESS: 'SET_REMINDER_TO_PUBLISH_DIGEST_SUCCESS',
  FAIL: 'SET_REMINDER_TO_PUBLISH_DIGEST_FAIL',
};
export const SEARCH_CAMPAIGNS_LIST = {
  SET_SEARCH: 'SEARCH_CAMPAIGNS_LIST_SET_SEARCH',
  LOAD: 'SEARCH_CAMPAIGNS_LIST_LOAD',
  SUCCESS: 'SEARCH_CAMPAIGNS_LIST_SUCCESS',
  FAIL: 'SEARCH_CAMPAIGNS_LIST_FAIL',
  RESET: 'SEARCH_CAMPAIGNS_LIST_RESET',
  SEARCH_FALSE: 'SEARCH_CAMPAIGNS_LIST_SEARCH_FALSE',
  RESET_ALL_FILTERS: 'RESET_ALL_FILTERS',
};

// default images
export const DEFAULT_CAMPAIGN_IMAGE = 'https://media.xiq.io/static/default_campaign_img.png';
export const DEFAULT_PERSON_IMAGE =
  'https://xiq-email-static.s3-us-west-2.amazonaws.com/11ceb038bdae4b28975b1ab9d0a00a0c/lib/pluginId_11ceb038bdae4b28975b1ab9d0a00a0c_user_8282/no_image_person.png';
export const GET_CAMPAIGNS_NAMES_ONLY = {
  LOAD: 'GET_CAMPAIGNS_NAMES_ONLY_LOAD',
  SUCCESS: 'GET_CAMPAIGNS_NAMES_ONLY_SUCCESS',
  FAIL: 'GET_CAMPAIGNS_NAMES_ONLY_FAIL',
  UPDATE: 'GET_CAMPAIGNS_NAMES_ONLY_UPDATE',
  UPDATE_NAME: 'GET_CAMPAIGNS_NAMES_ONLY_UPDATE_NAME',
  ADD_NEW: 'GET_CAMPAIGNS_NAMES_ONLY_ADD_NEW',
  RESET: 'GET_CAMPAIGNS_NAMES_ONLY_RESET',
};

export const ASSETS_FILTER_DATA = {
  LOAD: 'ASSETS_FILTER_DATA_LOAD',
  SUCCESS: 'ASSETS_FILTER_DATA_LOAD_SUCCESS',
  FAIL: 'ASSETS_FILTER_DATA_LOAD_FAIL',
  RESET: 'ASSETS_FILTER_DATA_RESET',
  LOAD_ASSETS: 'CAMPAIGNS_FILTER_ASSETS_DATA_LOAD',
  SUCCESS_ASSETS: 'CAMPAIGNS_FILTER_ASSETS_DATA_LOAD_SUCCESS',
  FAIL_ASSETS: 'CAMPAIGNS_FILTER_ASSETS_DATA_LOAD_FAIL',
  SET_CAMPAIGN: 'ASSETS_FILTER_DATA_SET_CAMPAIGN',
  SET_USER: 'ASSETS_FILTER_DATA_SET_USER',
  SET_DATE: 'ASSETS_FILTER_DATA_SET_DATE',
  SET_IS_FILTER: 'ASSETS_FILTER_DATA_SET_FILTER',
  LOAD_USERS: 'ASSETS_FILTER_DATA_LOAD_USERS',
  SUCCESS_USERS: 'ASSETS_FILTER_DATA_LOAD_USERS_SUCCESS',
  FAIL_USERS: 'ASSETS_FILTER_DATA_LOAD_USERS_FAIL',
  RESET_ALL_FILTERS: 'ASSETS_FILTER_DATA_RESET_ALL_FILTERS',
};

export const PREVIOUSLY_SENT_CONTENT = {
  LOAD: 'PREVIOUSLY_SENT_CONTENT_LOAD',
  LOAD_SUCCESS: 'PREVIOUSLY_SENT_CONTENT_SUCCESS',
  LOAD_FAIL: 'PREVIOUSLY_SENT_CONTENT_FAIL',
  ADD_FAVOURITE: 'PREVIOUSLY_SENT_CONTENT_ADD_FAVOURITE',
  REMOVE_FAVOURITE: 'PREVIOUSLY_SENT_CONTENT_REMOVE_FAVOURITE',
  RESET: 'PREVIOUSLY_SENT_CONTENT_RESET',
};

export const TEST_CAMPAIGN_SEARCH_TERM = {
  LOAD: 'TEST_CAMPAIGN_SEARCH_TERM_LOAD',
  SUCCESS: 'TEST_CAMPAIGN_SEARCH_TERM_SUCCESS',
  FAIL: 'TEST_CAMPAIGN_SEARCH_TERM_FAIL',
  RESET: 'TEST_CAMPAIGN_SEARCH_TERM_RESET',
};
export const CREATE_NEW_DRAFT_EDITION = {
  LOAD: 'CREATE_NEW_DRAFT_EDITION_LOAD',
  LOAD_SUCCESS: 'CREATE_NEW_DRAFT_EDITION_SUCCESS',
  LOAD_FAIL: 'CREATE_NEW_DRAFT_EDITION_FAIL',
};

export const ADHOC = {
  // ADHOC Asset Actions
  TEMPLATES_LOAD: 'ADHOC_TEMPLATES_LOAD',
  TEMPLATES_SUCCESS: 'ADHOC_TEMPLATES_SUCCESS',
  ERROR_SEARCH_TERM: 'ADHOC_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'ADHOC_ERROR_SEARCH_TERM_LOADING',
  TEMPLATES_FAIL: 'ADHOC_TEMPLATES_FAIL',
  SAVE_LOAD: 'ADHOC_SAVE_LOAD',
  SAVE_FAIL: 'ADHOC_SAVE_FAIL',
  RESET_URL: 'ADHOC_RESET_URL',
  FILTER_TEMPLATE: 'ADHOC_FILTER_TEMPLATE',
  RESET_PAGE_NUMBER: 'ADHOC_RESET_PAGE_NUMBER',
};

export const AIEMAIL = {
  // AIEMAIL Asset Actions
  SET_LOADING: 'SET_AIEMAIL_EMAIL_LOADING',
  AIEMAIL_SUCCESS: 'AIEMAIL_EMAIL_SUCCESS',
  RESET: 'AIEMAIL_RESET_EMAIL_DATA',
  SET_DESIGN: 'SET_AIEMAIL_EMAIL_DESIGN',
  UPDATE_DESIGN: 'UPDATE_AIEMAIL_EMAIL_DESIGN',
  EMAIL_VISITED: 'SET_AIEMAIL_EMAIL_VISITED',
  UPDATE_SUBJECT: 'AIEMAIL_EMAIL_SUBEJCT_UPDATE',
  UPDATE_NAME: 'AIEMAIL_UPDATE_EMAIL_NAME',
  SUBJECT_LOADING: 'AIEMAIL_SUBJECT_LOADING',
  UPDATE_THUMBNAIL: 'AIEMAIL_UPDATE_PREVIEW_THUMBNAIL',
  SET_AUDIENCE: 'SET_AIEMAIL_AUDIENCE',
  SET_PROMPT: 'SET_AIEMAIL_PROMT',
  ADD_NEW_EMAILS: 'AIEMAIL_ADD_NEW_EMAILS',
  UPDATE_AUDIENCE_COUNT: 'AIEMAIL_UPDATE_AUDIENCE_COUNT',
  RESET_AUDIENCE: 'AIEMAIL_RESET_AUDIENCE',
  RESET_DESIGN: 'AIEMAIL_RESET_DESIGN',
  SET_CONTACTS: 'AIEMAIL_SET_CONTACTS',
  SET_EMAILNAME: 'AIEMAIL_SET_EMAILNAME',
  SET_CAMPAIGN: 'AIEMAIL_SET_CAMPAIGN',
  SET_INPUT_PROMPT: 'AIEMAIL_SET_INPUT_PROMPT',
};

export const GET_ASSET_REMINDER = {
  LOAD: 'GET_ASSET_REMINDER_LOAD',
  SUCCESS: 'GET_ASSET_REMINDER_SUCCESS',
  FAIL: 'GET_ASSET_REMINDER_FAIL',
};

export const POST_ASSET_REMINDER = {
  LOAD: 'POST_ASSET_REMINDER_LOAD',
  SUCCESS: 'POST_ASSET_REMINDER_SUCCESS',
  FAIL: 'POST_ASSET_REMINDER_FAIL',
};

export const CAMPAIGN_UPDATE_LAST_UPDATED = {
  LOAD: 'CAMPAIGN_UPDATE_LAST_UPDATED_LOAD',
  SUCCESS: 'CAMPAIGN_UPDATE_LAST_UPDATED_SUCCESS',
  FAIL: 'CAMPAIGN_UPDATE_LAST_UPDATED_FAIL',
};
